import CompanyView from "./CompanyView";
export default CompanyView;